import { format } from 'date-fns';

/**
 * Utility functions for CalendarView
 */

/** Create a unique cell key for site + date combination */
export const createCellKey = (siteId: string, date: Date | string): string => {
  const dateString = date instanceof Date ? format(date, 'yyyy-MM-dd') : date;
  return `${siteId}:${dateString}`;
};

/** Create a storage key for draft job name */
export const createDraftJobKey = (
  siteId: string,
  date: Date | string
): string => {
  return `draft.job.${createCellKey(siteId, date)}`;
};

/**
 * Create a simple content hash for an array of calendar jobs
 * Only hashes fields that affect rendering to avoid unnecessary recalculations
 */
export const createCalendarHash = (
  calendar: Array<{
    id: string;
    status: string;
    start: string;
    end?: string | null;
    filtered?: boolean;
  }> | null
): string => {
  if (!calendar || calendar.length === 0) return '';

  // Hash only the minimal fields needed for change detection
  // This is much faster than hashing all fields
  return calendar
    .map((job) => `${job.id}:${job.status}:${job.filtered ?? false}`)
    .join(',');
};
